import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  footerLogo: {
    position: 'fixed',
    bottom: 0,
    left: '50%',
    transform: 'translateY(0) translateX(-50%)',
    zIndex: 1000,
    backgroundColor: theme.palette.primary.contrastText,

    width: '100%',
    height: '100%',
    maxHeight: '2.025rem',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    padding: '1rem 0rem',

    '& img': {
      width: '100px',
      heigth: '100%',
      maxHeight: '25px',
      paddingBottom: '0.125rem',
    },
  },
}))

export { useStyles }
